<template>
  <div id="app">
    <div id="nav">
      <div>
        <navi v-show="isWeb" />
        <m-navi v-show="isMobile" />
        <router-view
          id="MAIN_CON"
          class="main_contents"
          :style="{minHeight: footer_height}"
        />
        <foot></foot>
      </div>
    </div>
  </div>
</template>

<script>
import MNavi from "./components/mobile-navi.vue";
import Navi from "./components/Navi.vue";
import Foot from "./views/Footer.vue";

export default {
  components: {Foot, Navi, MNavi},
  data() {
    return {
      footer_height: "",
      isMobile: false,
      isWeb: false,
    };
  },
  methods: {
    getFooterSize() {
      var height;
      height = document.getElementById("FOOTER").clientHeight;
      height = height + "px";
      height = "calc(100vh - " + height + ")";
      this.footer_height = height;
    },

    checkMobile() {
      if (innerWidth < 1100) {
        this.isMobile = true;
        this.isWeb = false;
      } else {
        this.isMobile = false;
        this.isWeb = true;
      }
    },
  },
  mounted() {
    this.getFooterSize();

    // CMS에서 홈페이지 링크 열 때
    if (window.name == "info") {
      this.$router.push("/info");
    } else if (window.name == "map") {
      this.$router.push("/info/map");
    }
  },

  beforeUpdate() {
    this.checkMobile();
    window.addEventListener("resize", this.getFooterSize);
  },
  destroyed() {
    window.removeEventListener("resize", this.getFooterSize);
  },
};
</script>
<style>
@import "./assets/source/css/style.css";
* {
  padding: 0;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2f2e2e;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow: overlay;
}

#nav a {
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #f83f1b;
}
</style>
